import InvestorComplaintBanner from './InvestorComplaintBanner';
import InvestorComplaintSection from './InvestorComplaintSection';

function InvestorComplaint() {
  return (
    <div>
      <InvestorComplaintBanner />
      <InvestorComplaintSection />
    </div>
  );
}

export default InvestorComplaint;